import { FunctionComponent } from "react";

import { useTranslation } from "react-i18next";

/**
 * "← Back to {name}" strip shown above the detail panel while it is showing a colleague picked from
 * the Profiles tab, so the rep can always get back to the lead the table selected (PREC-4116).
 *
 * Sits outside the scroll container on purpose: a lead panel is scrolled constantly, and a way back
 * that scrolls away is a way back the rep has to hunt for.
 */
export const LeadPanelBackBar: FunctionComponent<{ name: string; onBack: () => void }> = ({
	name,
	onBack,
}) => {
	const { t } = useTranslation();

	return (
		<button
			className="flex w-full shrink-0 cursor-pointer items-center gap-1.5 border-b border-border-light bg-white px-4 py-2 text-left text-xs font-semibold text-blue-action"
			data-testid="lead-panel-back-bar"
			type="button"
			onClick={onBack}
		>
			<span aria-hidden>←</span>
			<span className="truncate">{t("contacts.leadPanel.backTo", { name })}</span>
		</button>
	);
};
